import "@hotwired/turbo-rails";
import { Application } from "@hotwired/stimulus";
import HeroFormController from "../controllers/frontend/hero_form_controller";
import FormController from "../controllers/frontend/form_controller";
import LightboxController from "../controllers/frontend/lightbox_controller";
import MapController from "../controllers/frontend/map_controller";
import PricingController from "../controllers/frontend/pricing_controller";
import CurrencyController from "../controllers/frontend/currency_controller";

const application = Application.start();
application.register("frontend--hero-form", HeroFormController);
application.register("frontend--form", FormController);
application.register("frontend--lightbox", LightboxController);
application.register("frontend--map", MapController);
application.register("frontend--pricing", PricingController);
application.register("frontend--currency", CurrencyController);
